export default "__VITE_ASSET__CQpiQu5P__"